function transformAvailabilityOverrideData(data) {
  return data.map((entry) => ({
    available: entry.available,
    lineId: entry.line,
    overrideDate: entry.date,
    shiftId: entry.shift,
  }));
}

export { transformAvailabilityOverrideData };
